module.exports = __webpack_public_path__ + "static/media/dice-d12.c4567ac5.svg";